export const convertFileCloudToLocal = async (file) => {
    try {
        // console.log(`Start convert file ${file.name} to local first`);
        const convertedFile = await new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                try {
                    // console.log(
                    //     `Start convert file ${file.name} to local reader.onload start`
                    // );
                    const blob = new Blob([reader.result], { type: file.type });
                    // Use a different variable name to avoid shadowing the 'file' parameter
                    const newFile = new File([blob], file.name, {
                        type: file.type,
                        lastModified: file.lastModified,
                    });
                    // console.log(
                    //     `Finish convert file ${newFile.name} to local reader.onload end`
                    // );
                    // Clear
                    resolve(newFile);
                } catch (e) {
                    reject(e);
                }
            };

            reader.onerror = () => {
                // The 'reader.error' property contains the error object
                reject(reader.error);
            };
            // console.log(
            //     `Start convert file ${file.name} to local reader.readAsArrayBuffer`
            // );
            reader.readAsArrayBuffer(file);
        });
        // console.log(`Finish convert file ${file.name} to local successfully`);
        return convertedFile;
    } catch (error) {
        console.error(`Error converting file "${file.name}":`, error);
        // Returning the original file might lead to the same upload issue.
        // It's safer to either re-throw the error or return null/undefined
        // so the calling function knows the conversion failed.
        // For now, returning the original file as per your code.
        return file;
    }
};
